import {
  type DashboardActions,
  InternalProjectActions as Internal,
} from '@store/reducers/dashboard/actions'
import { call, put } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { NestClient } from '@/nest'

export function* deleteSaga({
  payload: { id },
}: ReturnType<typeof DashboardActions.projects.delete>) {
  yield put(Internal.delete({ id }))

  sendGtmEvent(GtmTriggerName.PROJECT_DELETE)
  yield call(NestClient.projects.delete, { ids: [id] })
}
